import { roundToThreeDecimals } from '../../../helpers/modules';

export const billCalculation = (detailBill) => {
    const tvaMap = [];

    detailBill?.list?.forEach((el) => {
        const tvaRate = el?.tva ?? 0;
        const existingIndex = tvaMap.findIndex((item) => item.tvaRate === tvaRate);

        const quantity = el?.quantity || 0;
        const priseProductHT = el?.prise_product_HT || 0;
        const remise = el?.remise || 0;
        const tva = el?.tva || 0;
        
        const montantHT = priseProductHT * quantity;
        const montantAfterRemise = montantHT * (1 - remise / 100);
        const tvaAmount = montantAfterRemise * (tva / 100);
        const totalTTC = montantAfterRemise + tvaAmount;

        if (existingIndex !== -1) {
            tvaMap[existingIndex].BASE += montantAfterRemise;
            tvaMap[existingIndex].TOTAL_TAXE += tvaAmount;
            tvaMap[existingIndex].TOTAL_TCC += totalTTC;
        } else {
            tvaMap.push({
                CODE: 'C' + tva,
                TAUX: tva,
                tvaRate: tvaRate,
                BASE: montantAfterRemise,
                TOTAL_TAXE: tvaAmount,
                REMISE: montantHT - montantAfterRemise,
                TOTAL_TCC: totalTTC,
            });
        }
    });

    return tvaMap;
};

export const finalTotal = (tvaMap, timbreCount = 0) => {
    let totalHT = 0;
    let totalTCC = 0;
    let totalRemise = 0;
    
    const ctiAmount = 1;

    for (const item of tvaMap) {
        totalHT = Number((totalHT + item.BASE).toFixed(3));
        totalRemise = Number((totalRemise + (item.REMISE || 0)).toFixed(3));
        totalTCC = Number((totalTCC + item.TOTAL_TCC).toFixed(3));
    }
    
    const totalTCCWithCTI = Number((totalTCC + ctiAmount).toFixed(3));
    
    return {
        TOTAL_HT: totalHT,
        TOTAL_REMISE: totalRemise,
        TOTAL_TIMBRE: timbreCount,
        TOTAL_CTI: ctiAmount,
        TOTAL_TCC_WITHOUT_TIMBRE: totalTCCWithCTI,
        TOTAL_TCC: totalTCC,
    };
};

export const total = (detailBill, timbreCount = 0) => {
    const tvaMap = billCalculation(detailBill);
    let totalBase = 0;
    let totalTVA = 0;
    
    tvaMap.forEach((el) => {
        totalBase += el.BASE;
        totalTVA += el.TOTAL_TAXE;
    });
    
    const totalTimbre = timbreCount;
    
    return (
        <tr className="bt-head-4">
            <td>Total</td>
            <td>{roundToThreeDecimals(totalBase)} DT</td>
            <td></td>
            <td>{roundToThreeDecimals(totalTVA + totalTimbre)} DT</td>
        </tr>
    );
};

export const totalNet = (detailBill, timbreCount = 0) => {
    const tvaMap = billCalculation(detailBill);
    const totalProducts = tvaMap.reduce((a, b) => a + b.TOTAL_TCC, 0);
    const totalTimbre = timbreCount;
    return roundToThreeDecimals(totalProducts + totalTimbre);
};

export const convertNumberToWords = (n) => {
    if (n < 0) return false;
    if (n === 0) return 'Zéro';

    const units = ['', 'Un', 'Deux', 'Trois', 'Quatre', 'Cinq', 'Six', 'Sept', 'Huit', 'Neuf'];
    const teens = [
        'Dix', 'Onze', 'Douze', 'Treize', 'Quatorze', 'Quinze', 
        'Seize', 'Dix-sept', 'Dix-huit', 'Dix-neuf'
    ];
    const tens = [
        '', '', 'Vingt', 'Trente', 'Quarante', 'Cinquante', 
        'Soixante', 'Soixante-dix', 'Quatre-vingts', 'Quatre-vingt-dix'
    ];

    const translate = (num) => {
        let word = '';

        if (num < 10) {
            word = units[num];
        } else if (num < 20) {
            word = teens[num - 10];
        } else if (num < 100) {
            const unit = num % 10;
            const ten = Math.floor(num / 10);
            if (unit === 0) {
                word = tens[ten];
            } else if (ten >= 7 && ten <= 9) {
                const teenUnit = unit;
                if (ten === 7) {
                    word = 'Soixante-' + teens[teenUnit];
                } else if (ten === 8) {
                    word = 'Quatre-vingt-' + units[teenUnit];
                } else {
                    word = 'Quatre-vingt-dix-' + teens[teenUnit];
                }
            } else {
                word = tens[ten] + '-' + units[unit];
            }
        } else if (num < 1000) {
            const hundreds = Math.floor(num / 100);
            const remainder = num % 100;
            word = units[hundreds] + ' Cent';
            if (remainder > 0) {
                word += ' ' + translate(remainder);
            }
        } else if (num < 1000000) {
            const thousands = Math.floor(num / 1000);
            const remainder = num % 1000;
            word = translate(thousands) + ' Mille';
            if (remainder > 0) {
                word += ' ' + translate(remainder);
            }
        } else {
            const millions = Math.floor(num / 1000000);
            const remainder = num % 1000000;
            word = translate(millions) + ' Million';
            if (remainder > 0) {
                word += ' ' + translate(remainder);
            }
        }
        return word;
    };

    const dinar = Math.floor(n / 1000);
    const millimes = n % 1000;
    
    let result = '';
    if (dinar > 0) {
        result += translate(dinar) + ' Dinar';
        if (dinar > 1) result += 's';
    }
    if (millimes > 0) {
        if (dinar > 0) result += ' et ';
        result += translate(millimes) + ' Millime';
        if (millimes > 1) result += 's';
    }
    
    return result;
};